export const getRebookPolicy = (state) => state.rebookPolicy.rebookPolicy;
export const getRebookPolicyFetchStatus = (state) => state.rebookPolicy.fetchStatus;
